import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

export default {
    localization: {
        getGrid() {
            return axios.get(ApiRouteProvider.i18n.grid());
        },

        getTranslations(key) {
            return axios.get(ApiRouteProvider.i18n.gridTranslations(key));
        },

        saveTranslations(key, translations) {
            return axios.patch(ApiRouteProvider.i18n.saveTranslations(key), translations);
        }
    },

    services: {
        getGrid() {
            return axios.get(ApiRouteProvider.system.services.grid());
        },
        getHierarchy() {
            return axios.get(ApiRouteProvider.system.services.hierarchy());
        },
        card(id) {
            return axios.get(ApiRouteProvider.system.services.card(id));
        },
        userInterfaces(id) {
            return axios.get(ApiRouteProvider.system.services.userInterfaces(id));
        },
        create(service, userInterfaces) {
            return axios.post(ApiRouteProvider.system.services.create(), {
                ...service,
                userInterfaces: userInterfaces.map(ui => ui.id)
            });
        },
        save(id, service, userInterfaces) {
            return axios.put(ApiRouteProvider.system.services.card(id), {
                ...service,
                userInterfaces: userInterfaces.map(ui => ui.id)
            });
        },
    },

    scheduler: {
        getTasks(filters, page = 1, perPage = 20) {
            return axios.get(ApiRouteProvider.system.scheduler.tasks({
                ...filters,
                page,
                perPage,
            }));
        },

        getTask(id) {
            return axios.get(ApiRouteProvider.system.scheduler.task(id));
        },

        cancelTask(id) {
            return axios.post(ApiRouteProvider.system.scheduler.cancelTask(id), {});
        },

        rescheduleTask(id, payload) {
            return axios.post(ApiRouteProvider.system.scheduler.rescheduleTask(id), payload);
        },
    },

    email: {
        validateSmtp(email, password, host, port, emailProvider, existingConfiguration) {
            port = parseInt(port);

            const params = {
                email,
                password,
                emailProvider: emailProvider ? emailProvider.id : null
            };

            if (host && port) {
                params.host = host;
                params.port = port;
            }

            if (existingConfiguration && existingConfiguration.id) {
                return axios.put(ApiRouteProvider.system.email.validateConfiguration(existingConfiguration.id), params);
            }
            return axios.post(ApiRouteProvider.system.email.validateSmtp(), params);
        },
        searchEmailConfiguration(email) {
            return axios.get(ApiRouteProvider.system.email.searchConfiguration({email}));
        },
        getConfiguration(id) {
            return axios.get(ApiRouteProvider.system.email.getConfiguration(id));
        },

        getProviders() {
            return Cache.item('EmailProviders', () => {
                return axios.get(ApiRouteProvider.system.email.getProviders());
            }).getPromise();
        },

        sendInvitation(email, providerId, path) {
            return axios.post(ApiRouteProvider.system.email.sendInvitation(), {
                email,
                providerId,
                redirectPath: path
            });
        },

        deleteConfiguration(id) {
            return axios.delete(ApiRouteProvider.system.email.getConfiguration(id));
        },

        getConfigurations() {
            return axios.get(ApiRouteProvider.system.email.getConfigurations());
        },

        resendRequestEmail(productRequestId) {
            return axios.post(ApiRouteProvider.system.email.resendRequestEmail(productRequestId), {
                sentRequestId: productRequestId
            });
        },

        resolveEmailProvider(email) {
            return axios.post(ApiRouteProvider.system.email.resolveEmailProvider(), {
                email
            });
        },

        getResolveEmailProviderState(id) {
            return axios.get(ApiRouteProvider.system.email.getResolveEmailProviderState(id));
        }
    },

    security: {
        getOperations() {
            return Cache.item('SecurityOperations', () => {
                return axios.get(ApiRouteProvider.system.security.operations());
            }).getPromise();
        },

        getUserInterfaces(filters, sorting, page, perPage) {
            return axios.get(ApiRouteProvider.system.security.userInterfaces({
                filters,
                sort: sorting,
                page,
                perPage
            }))
        },

        addUserInterface(title, type, attributes) {
            return axios.post(ApiRouteProvider.system.security.addUserInterface(), {
                title, type, attributes
            });
        },

        saveUserInterface(id, ui) {
            return axios.put(ApiRouteProvider.getBaseUrl() +  '/system/security/user-interfaces/' + id, ui);
        },

        getUserInterfaceCard(id) {
            return axios.get(ApiRouteProvider.getBaseUrl() +  '/system/security/user-interfaces/' + id);
        }
    },

    legalIdentity: {
        getTypes() {
            return Cache.item('LegalIdentityTypes', () => {
                return axios.get(ApiRouteProvider.getBaseUrl() + '/system/legal-identity-types');
            }).getPromise();
        }
    }
}
